import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Alert, Button, Card, Flex, Form, Input, message, Modal, Typography } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useState } from "react";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/CompanyPage.module.less";
const { Text } = Typography;
/** Переходы статуса (BR-CMP-05): ACTIVE ⇄ SUSPENDED, ACTIVE/SUSPENDED → ARCHIVED; из ARCHIVED — нет (NQ-16). */
const ACTIONS = {
    ACTIVE: [
        {
            target: "SUSPENDED",
            label: "Приостановить",
            title: "Приостановить компанию?",
            consequence: "Новые корпоративные заказы будут отклоняться. Уже созданные заказы выполнятся и будут начислены компании (D10). Привязки, корп-админы, счета и оплаты продолжают работать.",
            danger: false,
        },
        {
            target: "ARCHIVED",
            label: "Архивировать",
            title: "Архивировать компанию?",
            consequence: "Возврат из архива не предусмотрен. Активные и будущие привязки сотрудников будут закрыты, новые привязки и корп-заказы станут невозможны. Компания с незавершёнными корпоративными заказами не архивируется.",
            danger: true,
        },
    ],
    SUSPENDED: [
        {
            target: "ACTIVE",
            label: "Возобновить",
            title: "Возобновить работу компании?",
            consequence: "Сотрудники снова смогут оформлять заказы за счёт компании.",
            danger: false,
        },
        {
            target: "ARCHIVED",
            label: "Архивировать",
            title: "Архивировать компанию?",
            consequence: "Возврат из архива не предусмотрен. Активные и будущие привязки сотрудников будут закрыты, новые привязки и корп-заказы станут невозможны. Компания с незавершёнными корпоративными заказами не архивируется.",
            danger: true,
        },
    ],
    ARCHIVED: [],
};
const SUCCESS_TEXT = {
    ACTIVE: "Компания снова активна",
    SUSPENDED: "Компания приостановлена",
    ARCHIVED: "Компания в архиве",
};
/**
 * Смена статуса компании (P-3) — монтируется ТОЛЬКО для ADMINISTRATOR (D14, `corp_company_set_status`).
 * Причина обязательна, действие подтверждается (BR-UI-03).
 */
const CompanyStatusActions = observer(() => {
    const { singleCompanyStore: store } = getRootStore();
    const [action, setAction] = useState(null);
    const [form] = Form.useForm();
    const company = store.company;
    if (!company)
        return null;
    const actions = ACTIONS[company.status];
    const handleConfirm = async () => {
        if (!action)
            return;
        const values = await form.validateFields().catch(() => null);
        if (!values)
            return;
        const { reason } = values;
        const result = await store.setStatus(action.target, reason.trim());
        if (!result)
            return;
        const linksText = action.target === "ARCHIVED"
            ? result.linksEnded !== null
                ? `. Закрыто привязок: ${result.linksEnded}`
                : ". Активные и будущие привязки закрыты"
            : "";
        message.success(`${SUCCESS_TEXT[action.target]}${linksText}`);
        setAction(null);
        form.resetFields();
    };
    return (_jsxs(Card, { title: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438", className: styles.section, children: [actions.length === 0 ? (_jsx(Text, { type: "secondary", children: "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0432 \u0430\u0440\u0445\u0438\u0432\u0435. \u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u0438\u0437 \u0430\u0440\u0445\u0438\u0432\u0430 \u043D\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D." })) : (_jsx(Flex, { gap: 12, wrap: "wrap", children: actions.map((item) => (_jsx(Button, { danger: item.danger, onClick: () => setAction(item), disabled: store.isSaving, children: item.label }, item.target))) })), _jsxs(Modal, { open: action !== null, title: action?.title, okText: action?.label, okButtonProps: { danger: action?.danger, loading: store.isSaving }, cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430", onOk: handleConfirm, onCancel: () => {
                    setAction(null);
                    form.resetFields();
                }, destroyOnHidden: true, children: [action ? _jsx(Alert, { type: action.danger ? "warning" : "info", showIcon: true, message: action.consequence, className: styles.notice }) : null, _jsx(Form, { form: form, layout: "vertical", children: _jsx(Form.Item, { name: "reason", label: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430", rules: [{ required: true, whitespace: true, message: "Укажите причину смены статуса" }], children: _jsx(Input.TextArea, { autoSize: { minRows: 2, maxRows: 5 }, maxLength: 500, showCount: true }) }) })] })] }));
});
CompanyStatusActions.displayName = "CompanyStatusActions";
export default CompanyStatusActions;
